import React, { useContext } from 'react';

import { FormContext } from './Form';
import './Form.module.css';

const Submit = ({ label, ...props }) => {
  const { formId, isSubmitting } = useContext(FormContext);

  return (
    <button
      {...props}
      form={formId}
      type="submit"
      styleName="submit"
      disabled={isSubmitting}
    >
      {label}
    </button>
  );
};

export default Submit;
